(() => {
  function setup(scope) {
    scope.querySelectorAll('[data-cascade-nav]').forEach(nav => {
      if (nav.dataset.cascadeReady) return;
      nav.dataset.cascadeReady = 'true';
      const roots = Array.from(nav.querySelectorAll(':scope > .cascade-root'));
      const hover = () => nav.classList.contains('desktop-nav') && matchMedia('(min-width: 1101px) and (hover: hover) and (pointer: fine)').matches;
      const timers = new WeakMap();
      const clear = detail => { clearTimeout(timers.get(detail)); timers.delete(detail); };
      const close = detail => { clear(detail); detail.open = false; detail.querySelectorAll('details[open]').forEach(child => child.open = false); };
      const fit = detail => {
        const panel = detail.querySelector(':scope > .cascade-panel');
        if (!panel || !nav.classList.contains('desktop-nav')) return;
        detail.classList.remove('cascade-align-right'); panel.classList.remove('cascade-flip');
        if (panel.getBoundingClientRect().right > innerWidth - 20) detail.classList.add('cascade-align-right');
        panel.classList.toggle('cascade-flip', panel.getBoundingClientRect().right + 268 > innerWidth - 20);
      };
      const openRoot = detail => { roots.filter(root => root !== detail).forEach(close); detail.open = true; fit(detail); };
      roots.forEach(detail => {
        detail.querySelector(':scope > summary')?.addEventListener('click', () => {
          clear(detail); roots.filter(root => root !== detail).forEach(close);
        });
        detail.addEventListener('toggle', () => { if (detail.open) { roots.filter(root => root !== detail).forEach(close); fit(detail); } });
        detail.addEventListener('pointerenter', () => { clear(detail); if (hover()) timers.set(detail, setTimeout(() => openRoot(detail), 100)); });
        detail.addEventListener('pointerleave', () => { clear(detail); if (hover() && !detail.contains(document.activeElement)) timers.set(detail, setTimeout(() => close(detail), 180)); });
        detail.querySelectorAll('.cascade-child').forEach(child => {
          const closeSiblings = () => detail.querySelectorAll('.cascade-child').forEach(other => { if (other !== child) close(other); });
          child.querySelector(':scope > summary')?.addEventListener('click', () => { clear(child); closeSiblings(); });
          child.addEventListener('pointerenter', () => { clear(child); if (hover()) timers.set(child, setTimeout(() => { closeSiblings(); child.open = true; fit(detail); }, 80)); });
          child.addEventListener('pointerleave', () => { clear(child); if (hover() && !child.contains(document.activeElement)) timers.set(child, setTimeout(() => close(child), 180)); });
          child.addEventListener('toggle', () => { if (child.open) closeSiblings(); });
        });
      });
      nav.addEventListener('keydown', event => {
        const detail = event.target.closest('details');
        if (!detail) return;
        if (event.key === 'Escape') {
          const target = detail.open ? detail : detail.parentElement.closest('details[open]');
          if (target) { event.preventDefault(); event.stopPropagation(); close(target); target.querySelector(':scope > summary')?.focus(); }
          return;
        }
        if (event.target.tagName === 'SUMMARY' && ['ArrowDown', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
          if (detail.classList.contains('cascade-root')) openRoot(detail); else detail.open = true;
          detail.querySelector(':scope > div a, :scope > div summary')?.focus();
        }
      });
      document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) roots.forEach(close); });
      nav.addEventListener('focusout', event => { if (!nav.contains(event.relatedTarget)) roots.forEach(close); });
      window.addEventListener('resize', () => roots.filter(root => root.open).forEach(fit));
      if (nav.classList.contains('mobile-nav')) matchMedia('(min-width: 1101px)').addEventListener('change', event => {
        if (!event.matches) return;
        roots.forEach(close); nav.hidden = true;
        document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
